import React from 'react';

export const IconUpload = () => (
  <svg viewBox="0 0 13 14">
    <path
      clipRule="evenodd"
      d="M5.9,2.4L4.5,3.8C4.3,4,3.9,4,3.7,3.8C3.4,3.5,3.4,3.2,3.7,2.9L6.1,0.5C6.1,0.5,6.1,0.5,6.2,0.4C6.2,0.4,6.2,0.4,6.3,0.4C6.4,0.3,6.6,0.3,6.7,0.4C6.8,0.4,6.9,0.4,6.9,0.5L9.3,2.9C9.6,3.2,9.6,3.5,9.3,3.8C9.2,3.9,9.1,4,8.9,4C8.7,4,8.6,3.9,8.5,3.8L7.1,2.4V9.4C7.1,9.8,6.9,10,6.5,10C6.1,10,5.9,9.8,5.9,9.4V2.4ZM12.6,11.8V10C12.6,9.7,12.3,9.4,12,9.4C11.6,9.4,11.3,9.7,11.3,10V11.8C11.3,12.2,11.1,12.4,10.7,12.4H2.3C1.9,12.4,1.7,12.2,1.7,11.8V10C1.7,9.7,1.4,9.4,1,9.4C0.7,9.4,0.4,9.7,0.4,10V11.8C0.4,12.9,1.2,13.7,2.3,13.7H10.7C11.8,13.7,12.6,12.9,12.6,11.8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
